import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { PersonProfile } from "./types";
import { getPersonData } from "./api";
import DEI from "./DEI";
import "./LandingPage.css";

const LandingPage: React.FC = () => {
  return (
    <div>
      <div className="landing-page">
        <Helmet key="Bloat@Brown">
          <title>Bloat@Brown</title>
          <meta
            name="description"
            content="We emailed every administrator. Now they have to justify their jobs. Track your tuition dollars through Brown's bureaucracy."
          />
        </Helmet>
        <h2 className="center-subtitle1">
          We emailed 3,805 administrators and flagged DEI jobs that risked
          federal funds. Instead of taking our advice, a{" "}
          <a
            className="link"
            target="_blank"
            href="https://www.thefire.org/news/brown-university-targets-student-journalist-sending-doge-emails"
          >
            disciplinary review
          </a>{" "}
          was launched.
        </h2>
        <h1 className="center-title">
          Meet the DEI bureaucrats who lost Brown University $510 million in
          federal funds.
        </h1>
        <h2 className="center-subtitle">
          AI flagged 49 Brown University employees potentially holding illegal
          DEI roles.
        </h2>
      </div>
      <DEI />
    </div>
  );
};

export default LandingPage;
